import { useEffect } from 'react';
import { useTenant } from '../../context/TenantContext';

const TENANT_PREFIX = 'tenant-';

export default function TenantEffects() {
  const { tenant } = useTenant();

  useEffect(() => {
    const className = `${TENANT_PREFIX}${tenant}`;

    document.body.classList.forEach((c) => {
      if (c.startsWith(TENANT_PREFIX)) document.body.classList.remove(c);
    });

    document.body.classList.add(className);

    return () => {
      document.body.classList.remove(className);
    };
  }, [tenant]);

  return null;
}
